"use client";

import type { CSSProperties, ReactElement } from "react";
import { CAREERS_CONTENT } from "./careers-content";
import { useCareersLanguage } from "./careers-language-context";
import { CareersProductMockup } from "./careers-product-mockup";

/** Same white 1300px stage card as the developers funnel work section. */
const CARD: CSSProperties = {
  position: "relative",
  borderRadius: 30,
  background: "#ffffff",
  border: "1px solid rgba(11,15,25,0.10)",
  boxShadow:
    "0 44px 84px -52px rgba(10,15,25,0.34), 0 10px 26px -18px rgba(10,15,25,0.10)",
  padding: "clamp(34px,4vw,64px) clamp(28px,4vw,62px)",
  overflow: "hidden",
};

const GRID: CSSProperties = {
  position: "relative",
  zIndex: 1,
  display: "grid",
  gridTemplateColumns: "1.42fr 0.75fr",
  gap: "clamp(30px,3.5vw,60px)",
  alignItems: "center",
};

/**
 * "Was ist hausverwalter.ai?" as the funnel stage: white card floating on the
 * dark canvas, product mockup left, copy + tag chips right.
 */
export function CareersWorkSection(): ReactElement {
  const { lang } = useCareersLanguage();
  const t = CAREERS_CONTENT[lang].work;

  return (
    <section id="about" className="dvf-section dvf-section-work">
      <div className="dvf-work-stage">
        <div className="careers-about-card" style={CARD}>
          <div className="careers-grid-2col" style={GRID}>
            <CareersProductMockup />
            <div className="dvf-work-copy c2-work-copy">
              <h2 className="dvf-section-title">{t.title}</h2>
              {t.paragraphs.map((paragraph) => (
                <p className="c2-work-para" key={paragraph}>
                  {paragraph}
                </p>
              ))}
              <div className="c2-tags">
                {t.tags.map((tag) => (
                  <span className="c2-tag" key={tag}>
                    {tag}
                  </span>
                ))}
                <span className="c2-tag-more">{t.more}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
